import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";

const state = {};

const getters = {};

const actions = {
  async add_photo(context, data) {
    return await asyncHandler(
      HTTP({ url: "/display-group/add-photo", method: "POST", data })
    );
  },

  async remove_photo(context, data) {
    return await asyncHandler(
      HTTP({ url: "/display-group/remove-photo", method: "POST", data })
    );
  },

  async save_displayGroup(context, data) {
    const url = data.id ? "/display-group/" + data.id : "/display-group";
    const method = data.id ? "PUT" : "POST";
    return await asyncHandler(HTTP({ url, method, data }));
  },

  async get_albums(context, data) {
    return await asyncHandler(
      HTTP({ url: "album/date-and-outfitter", data: data, method: "POST" })
    );
  },

  async get_displayGroups(context, data) {
    return await asyncHandler(
      HTTP({
        url: "display-group/date-and-outfitter",
        data: data,
        method: "POST",
      })
    );
  },
};

const mutations = {};

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state,
};
